"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M17.669 9.1001 12 3.9981 6.331 9.1l1.338 1.4866L12 6.6887l4.3311 3.898 1.3379-1.4866zm-10 4.3101-1.338 1.4865L12 19.9988l5.669-5.1021-1.3379-1.4865L12 17.3081l-4.331-3.8979z"
  })];
};

exports.default = _default;